import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IColorsPanelButtonProps } from './types';
import { BOARD_SECTION_COLORS } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function ColorsPanelButton ({
    indicatorNumber,
    tooltip,
    onClick
}: IColorsPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.COLOR_LABELS}
            indicatorNumber={indicatorNumber}
            title={BOARD_SECTION_COLORS}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.COLOR_LABELS);
                onClick();
            }}
        />
    );
}
